module.exports = __webpack_public_path__ + "assets/img/923013.0d8bda11.jpg";